import React from "react";
import { connect } from 'react-redux';
import * as fetchingState from '../../constants/fetchingState';
import { fetchOrderItems as fetchOrderItemsAction } from '../../actions/orderItems';
import { getOrderDebugInfo } from "../../actions/orders";
import { orderStateReport } from '../../constants/analytics';
import * as permissions from '../../constants/permissions'; 
import OrderFullInfo from './OrderFullInfo';

let OrderItems = class extends React.Component {

    constructor(props) {
        super(props);
        this._onSecretMenuClick = this._onSecretMenuClick.bind(this);
        this._onSecretMenuClose = this._onSecretMenuClose.bind(this);
        this.state = { showSecretMenu: false };
    }

    componentWillMount() {
        if (this.props.isReport)
            return;
        const { orderId, fetchOrderItemsAction, fetching, items } = this.props;
        if (fetching !== fetchingState.FETCHED && !items)
            fetchOrderItemsAction({ orderId });
    }

    _onSecretMenuClick() {
        this.props.getOrderDebugInfo(this.props.order.Id);
        this.setState({ showSecretMenu: true });
    }
    _onSecretMenuClose() {
        this.setState({ showSecretMenu: false });
    }

    render() {
        const { items, fetching, delivery, discount, isReport, isReceptionPoint, order } = this.props;
        const amount = isReport ? order.Total.Amount : fetching === fetchingState.FETCHED ? items.length > 0 ? items.map(a => a.Price * a.Amount).reduce((a, b) => a + b) : 0 : 0;
        const deliveryPrice = isReport ? order.Total.Delivery : (amount > delivery.FreeDeliveryAmount || isReceptionPoint) ? 0 : delivery.DeliveryPrice;
        const totalAmount = isReport ? order.Total.TotalAmount : deliveryPrice + amount + (discount ? discount : 0);
        const discountRowName = discount > 0 ? "Дополнительная услуга" : "Скидка";

        return (<div>
            {this.state.showSecretMenu && <OrderFullInfo orderInfo={this.props.orderdDebugInfo} fetching={this.props.orderdDebugInfoFetching} show={this.state.showSecretMenu} onClose={this._onSecretMenuClose} />}
            {fetching === fetchingState.FETCHING && <span>Загрузка...</span>}
            {fetching === fetchingState.FAILED && <span>Не удалось загрузить список услуг.</span>}
            {(fetching === fetchingState.FETCHED || isReport) && <table className='table table-hover'>
                <thead>
                    <tr>
                        <td>Услуга</td>
                        <td>Цена</td>
                        <td>Количество</td>
                    </tr>
                </thead>
                <tbody>
                    {items && items.map(i => (
                        <tr key={i.Id}>
                            <td>{i.Service}</td>
                            <td>{i.Price}</td>
                            <td>{i.Amount}</td>
                        </tr>)
                    )}
                    {items && items.length > 0 &&
                        <tr>
                            <td onDoubleClick={this._onSecretMenuClick}><strong>Сумма заказа</strong></td>
                            <td colSpan={2}><strong>{amount}</strong></td>
                        </tr>
                    }
                    {items && discount !== 0 &&
                        <tr>
                            <td><strong>{discountRowName}</strong></td>
                            <td colSpan={2}><strong>{discount}</strong></td>
                        </tr>
                    }
                    {items && items.length > 0 && !isReceptionPoint &&
                        <tr>
                            <td><strong>Доставка</strong></td>
                            <td colSpan={2}><strong>{deliveryPrice}</strong></td>
                        </tr>
                    }
                    {items && items.length > 0 &&
                        <tr>
                            <td><strong>Итог</strong></td>
                            <td colSpan={2}><strong>{totalAmount}</strong></td>
                        </tr>}
                </tbody>
            </table>}
        </div>);
    }
}

OrderItems = connect((state, props) => {
    const { orderId, isReport } = props;
    const isReceptionPoint = permissions.getRole() == permissions.RECEPTION_POINT;
    const orders = isReport ?
        state.application.get('reports')[orderStateReport].data.Orders :
        state.application.get('orders').get('orders');

    const order = orders.find(o => o.Id === orderId);
    if (!isReport && (!order || !order.itemsFetching)) {
        return { fetching: fetchingState.INITIAL };
    }
    return {
        order,
        items: order.Items,
        fetching: order.itemsFetching,
        isReceptionPoint,
        orderdDebugInfo: state.application.get('orders').get('fullOrderInfo'),
        orderdDebugInfoFetching: state.application.get('orders').get('debugInfoFetching')
    }

}, { fetchOrderItemsAction, getOrderDebugInfo })(OrderItems);

export default OrderItems;


// WEBPACK FOOTER //
// ./src/components/orders/OrterItems.jsx